import { Link } from "react-router-dom";
import placeholder from "../util/placeholder";
import { Button } from "../components/ui/button";
import { useCurrency } from "../hooks/useCurrency";
import useSWRMutation from "swr/mutation";
import { handleUpdates } from "../util/axiosConfig";
import { message } from "antd";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { useState } from "react";

function VehicleDetails({ vehicle }: { vehicle: Vehicle | null }) {
  const {formatCurrency} = useCurrency();
  const [status, setStatus] = useState(vehicle?.status);

  const { trigger: triggerUpdates, isMutating } = useSWRMutation(`newAdmin/vehicles/${vehicle?.id}/status`, handleUpdates);

  const handleStatusUpdate = async () => {
    if (!vehicle) return;
    try {
        const response = await triggerUpdates({
            status: vehicle?.status === 'active' ? "inactive" : "active",
            reason: vehicle?.status === 'active' ? "Deactivated by admin" : "Activated by admin"
        });
        setStatus(vehicle?.status === 'active' ? "inactive" : "active");
        message.success("Vehicle status updated successfully!");
    } catch (error) {
        console.error("Error updating vehicle status:", error);
    }
  }
  return (
            <div className="lg:w-[400px] bg-white rounded-lg shadow-sm border p-6 flex flex-col items-center">
                {/* Truck Card Header */}
                <div className="w-full flex items-center gap-3 bg-[#E3F2FD] rounded mb-6 p-3">
                    <img
                        src={vehicle?.truckCategoryDetails?.image || placeholder}
                        alt={vehicle?.truckCategoryDetails?.name}
                        className="w-12 h-12 rounded object-cover"
                    />
                    <div className="font-semibold text-[#1A237E] text-base">{vehicle?.truckCategoryDetails?.name}</div>
                </div>
                {/* Vehicle Details */}
                <div className="w-full">
                    <div className="font-semibold text-sm mb-1">{vehicle?.fleetOwner?.companyName}</div>
                    <div className="text-[#F9A825] text-sm mb-1">{vehicle?.regPlate}</div>
                    <div className="flex items-center gap-2 mb-4">
                    <span className="text-[#1A237E] text-sm">Status: </span>
                    <span className="text-[#1976D2] font-semibold uppercase text-sm cursor-pointer">{status ?? vehicle?.status}</span>
                    </div>
                    <div className="flex gap-8 mb-6">
                    <div className="flex flex-col items-center">
                        <span className="text-[#1A237E] font-bold text-2xl">{vehicle?.totalTrips}</span>
                        <span className="text-[#90A4AE] text-xs">Total Trips</span>
                    </div>
                    <div className="flex flex-col items-center">
                        <span className="text-[#1A237E] font-bold text-2xl">{formatCurrency(vehicle?.totalEarned || 0)}</span>
                        <span className="text-[#90A4AE] text-xs">Total Earnings</span>
                    </div>
                    </div>
                    {/* Driver Info */}
                    <div className="mb-4">
                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Driver Information</div>
                    <div className="text-[#1976D2] font-medium cursor-pointer">{vehicle?.driverName}</div>
                    <div className="text-[#90A4AE] text-xs">{vehicle?.driverPhone}</div>
                    </div>
                    {/* Location Info */}
                    <div className="mb-6">
                    <div className="font-semibold text-[#1A237E] text-xs mb-0.5">Location</div>
                    <div className="text-[#90A4AE] text-xs mb-1">Location information available for this vehicle</div>
                    <Link to="#" className="text-[#1976D2] text-xs">View Location</Link>
                    </div>
                    <Button
                        className="w-full bg-[#1976D2] text-white font-semibold py-2 rounded gap-2"
                        disabled={isMutating}
                        onClick={handleStatusUpdate}
                    >
                        <span>{vehicle?.status === 'active' ? "Deactivate Vehicle" : "Activate Vehicle"}</span>
                        {isMutating && <LoadingSpinner />}
                    </Button>
                </div>
            </div>
  )
}

export default VehicleDetails